import NavbarLayout from "../navbar-layout";
import {BreadLayout} from "../breadcrumbs";
import PaperLayout from "../paper";
import {SideBarProvider} from "../../contexts/drawer-context";
import React from "react";
import {StyledDefaultBackGround} from "./styles";
import Footer from "../footer";

export function Layout({children} : { children: any }) {
  return (
    <StyledDefaultBackGround>
      <SideBarProvider>
        <NavbarLayout/>
        <BreadLayout/>
        <PaperLayout>
          {children}
        </PaperLayout>
        <Footer />
      </SideBarProvider>
    </StyledDefaultBackGround>
  );
}
